import { render, staticRenderFns } from "./ManageWaivers.vue?vue&type=template&id=1f8fb6c7&scoped=true&"
import script from "./ManageWaivers.vue?vue&type=script&lang=js&"
export * from "./ManageWaivers.vue?vue&type=script&lang=js&"
import style0 from "./ManageWaivers.vue?vue&type=style&index=0&id=1f8fb6c7&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8fb6c7",
  null
  
)

export default component.exports